export default __webpack_public_path__ + "static/home-012cc593d7fe35b4b55130556db44a62.jpg";